import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as userActions from '../Actions/userActions';
import ProjectForm from "../Components/Project/ProjectForm";
import { orderService } from "../Services/OrderService.js";
import { withRouter } from 'react-router';

class ProjectFormContainer extends Component {
	constructor(props){
		super(props);

		this.mergePrject = this.mergePrject.bind(this);
	}
	
	mergePrject(){
		orderService.mergeProject(this.props.projectRecord.id)
			.then(() => {return this.props.history.push('/orderList')});
	}

	render() {
	    return (<ProjectForm	project={this.props.projectRecord}
								mergePrject={this.mergePrject}
								accessToken={this.props.user.access_token}/>);
	}
}

function mapStateToProps(state, ownProps) {
	//console.log( state.projects);
	//console.log( ownProps.match.params.id);
	return {user: state.user, projectRecord: state.projects.find(p => p.id == ownProps.match.params.id)}
}

function mapDispatchToProps(dispatch) {
	return {actions: bindActionCreators(Object.assign({}, userActions), dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectFormContainer);  